module.exports = __webpack_public_path__ + "img/Group.e0f244d9.svg";